import React from 'react';
import { Divider } from 'wix-ui-tpa/cssVars';
import { st, classes } from './Widget.st.css';
import { Header } from './Header';
import { Body } from './Body/Body';

export const Widget: React.FC = () => {
  return (
    <div className={st(classes.root, {})} data-hook="DailyAgenda-wrapper">
      <Header />
      <Divider className={classes.divider} />
      <Body />
    </div>
  );
};
